var isPlaying = false;
var playCount = 0;
var isSingleRotation = true;
